var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex alert alert-light px-4 py-3"},[_c('div',{staticClass:"my-auto"},[_vm._t("icon")],2),_c('div',{staticClass:"pl-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }